export default __webpack_public_path__ + "static/media/11_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A3616.22eb52dd.jpg";